module.exports = __webpack_public_path__ + "img/webmail.84dbb445.png";